<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1>Send Push</h1>
        </div>
        <div class="col-xs-6 mandatoryDiv">
          <span class="mandatory_color">(*)</span>
          <span class="letter-right"> Marked are required field</span>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-info" v-if="alert_message">
            {{ alert_message }}
          </div>
        </div>
        <form @submit.prevent="formSubmit" ref="myForm">
          <div class="col-sm-6">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Fill up the PIN information</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <div class="form-group device-div">
                  <label class="col-md-4 control-label">Send to </label>
                  <div class="col-md-8">
                    <v-select
                      v-model="formData.pin_type"
                      :options="[
                        // { value: '', name: 'All pin' },
                        { value: 'single', name: 'Single pin' },
                      ]"
                      label="name"
                      :reduce="(option) => option.value"
                      placeholder="--Select--"
                      @input="showPinTypeHide()"
                      class="input-sm"
                    ></v-select>
                  </div>
                </div>
                <div class="form-group username-div">
                  <label class="col-md-4 control-label"
                    >PIN with comma separated
                    <span class="mandatory_horizontal">*</span></label
                  >

                  <div class="col-md-8">
                    <textarea
                      v-model="formData.username"
                      id="username"
                      class="form-control input-sm"
                      rows="5"
                      placeholder="Enter PIN e.g. 12345,65412,1233,12345,65412,1233"
                    >
                    </textarea>
                    <small v-if="errors.username" class="text-danger">{{
                      errors.username
                    }}</small>
                  </div>
                </div>

                <div class="form-group status-div">
                  <label class="col-md-4 control-label">PIN Status </label>
                  <div class="col-md-8">
                    <div class="form-group">
                      <div class="col-md-4">
                        <input
                          v-model="formData.status.active"
                          type="checkbox"
                          id="status_active"
                          value="1"
                          checked
                        />
                        Active
                      </div>
                      <div class="col-md-4">
                        <input
                          v-model="formData.status.inactive"
                          type="checkbox"
                          id="status_inactive"
                          value="2"
                        />
                        In-active
                      </div>
                      <div class="col-md-4">
                        <input
                          v-model="formData.status.expired"
                          type="checkbox"
                          id="status_expired"
                          value="3"
                        />
                        Expired
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-6 control-label">Subscriptions </label>
                  <div class="col-md-6">
                    <div class="input-group">
                      <span class="input-group-addon">
                        <div class="inputFlex">
                          <input
                            v-model="formData.subscriptions_selection_type"
                            id="subscriptions_selection_include"
                            type="radio"
                            value="include"
                          />
                          <label
                            style="margin: 0px !important"
                            for="subscriptions_selection_include"
                            >Include
                          </label>
                        </div>
                      </span>
                      <span class="input-group-addon">
                        <div class="inputFlex">
                          <input
                            v-model="formData.subscriptions_selection_type"
                            id="subscriptions_selection_exclude"
                            type="radio"
                            value="exclude"
                          />
                          <label
                            style="margin: 0px !important"
                            for="subscriptions_selection_exclude"
                            >Exclude
                          </label>
                        </div>
                      </span>
                      <input type="hidden" />
                    </div>
                  </div>
                </div>

                <div class="form-group device-div">
                  <label class="col-md-6 control-label">Bundles </label>
                  <div class="col-md-6">
                    <v-select
                      v-model="rate_plan_id"
                      :options="bundles"
                      label="name"
                      :reduce="(bundle) => bundle.id"
                      placeholder="--Select--"
                      @input="loadRatePlans"
                      class="input-sm"
                    ></v-select>
                    <small v-if="errors.rate_plan_id" class="text-danger">{{
                      errors.rate_plan_id
                    }}</small>
                  </div>
                </div>
                <div class="form-group device-div">
                  <label class="col-md-6 control-label"> subscriptions </label>
                  <div class="col-md-6 trial-dropdown">
                    <v-select
                      v-model="formData.subscriptions"
                      :options="rateplans"
                      :reduce="(rateplan) => rateplan.id"
                      label="plan_name"
                      multiple
                      placeholder="--Select--"
                      class="input-sm"
                    >
                    </v-select>
                    <small v-if="errors.subscriptions" class="text-danger">{{
                      errors.subscriptions
                    }}</small>
                  </div>
                </div>
                <div>
                  <div class="form-group device-div">
                    <label class="col-md-4 control-label">
                      Country Filters
                    </label>

                    <div class="col-md-8">
                      <v-select
                        v-model="formData.country_filter_type"
                        :options="[
                          { id: '!=', label: 'is Except' },
                          { id: '=', label: 'is Equal' },
                        ]"
                        :reduce="(option) => option.id"
                        label="label"
                        placeholder="--Select--"
                        class="input-sm"
                      >
                      </v-select>
                    </div>
                  </div>

                  <div class="form-group device-div">
                    <label class="col-md-4 control-label"> Country </label>
                    <div class="col-md-8">
                      <v-select
                        v-model="formData.country"
                        :options="countries"
                        label="name"
                        multiple
                        placeholder="--Select--"
                        class="input-sm"
                      >
                      </v-select>
                      <small v-if="errors.country" class="text-danger">{{
                        errors.country
                      }}</small>
                    </div>
                  </div>

                  <!-- Target Device -->
                  <div class="form-group device-div">
                    <label class="col-md-4 control-label">
                      Target Device
                    </label>

                    <div class="col-md-8">
                      <v-select
                        v-model="formData.device_type"
                        :options="[
                          { id: '0', title: 'All Device' },
                          { id: '1', title: 'Android Only' },
                          { id: '2', title: 'iOS Only' },
                        ]"
                        label="title"
                        :reduce="(option) => option.id"
                        placeholder="--Select--"
                        class="input-sm"
                      >
                      </v-select>
                    </div>
                  </div>

                  <!-- Date Filter Column -->
                  <div class="form-group date-type-div">
                    <label class="col-md-4 control-label">
                      Date Filter Column
                    </label>

                    <div class="col-md-4">
                      <v-select
                        v-model="formData.date_column"
                        :options="[
                          {
                            value: 'after_activate_first_login_at',
                            label: 'After Activate First Login At',
                          },
                          { value: 'activate_at', label: 'Activate At' },
                          { value: 'validity_date', label: 'Validity Date' },
                        ]"
                        label="label"
                        :reduce="(option) => option.value"
                        placeholder="--Select--"
                        @input="checkDateColumn"
                        class="input-sm"
                      >
                      </v-select>
                      <small v-if="errors.date_column" class="text-danger">{{
                        errors.date_column
                      }}</small>
                    </div>
                    <div class="col-md-4">
                      <v-select
                        v-model="formData.date_condition"
                        :options="[
                          { value: 'between', text: 'Between' },
                          { value: 'not between', text: 'Not Between' },
                          { value: '=', text: 'Is Equal To', selected: true },
                          { value: '>', text: '>' },
                          { value: '>=', text: '>=' },
                          { value: '<', text: '<' },
                          { value: '<=', text: '<=' },
                          { value: '!=', text: '!=' },
                        ]"
                        label="text"
                        :reduce="(option) => option.value"
                        placeholder="--Select--"
                        @input="checkDateCondition"
                        class="input-sm"
                      >
                      </v-select>
                      <small v-if="errors.date_condition" class="text-danger">{{
                        errors.date_condition
                      }}</small>
                    </div>
                  </div>
                </div>

                <div class="form-group date-div">
                  <label class="col-md-4 control-label"> Date</label>
                  <div class="col-md-8">
                    <div class="col-md-6 form-group">
                      <input
                        placeholder="Start"
                        type="text"
                        v-model="formData.date_range.start"
                        id="starttime"
                        class="form-control input-sm datePicker"
                        autocomplete="off"
                      />
                      <small
                        v-if="errors.date_range_start"
                        class="text-danger"
                        >{{ errors.date_range_start }}</small
                      >
                    </div>
                    <div
                      class="col-md-6 form-group"
                      id="end-date-div"
                      v-show="showEndDate"
                    >
                      <input
                        placeholder="End"
                        type="text"
                        v-model="formData.date_range.end"
                        id="stoptime"
                        class="form-control input-sm datePicker"
                        autocomplete="off"
                      />
                      <small v-if="errors.date_range_end" class="text-danger">{{
                        errors.date_range_end
                      }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Fill up PUSH information</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <div class="pushForm">
                  <div class="form-group">
                    <label class="col-md-4 control-label"
                      >Title <span class="mandatory_horizontal">*</span></label
                    >
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model="formData.headings"
                        name="headings"
                        id="headings"
                        class="form-control input-sm"
                        placeholder="Enter Push Title"
                      />
                      <small v-if="errors.headings" class="text-danger">{{
                        errors.headings
                      }}</small>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-4 control-label"
                      >Message
                      <span class="mandatory_horizontal">*</span></label
                    >
                    <div class="col-md-8">
                      <textarea
                        v-model="formData.push_message"
                        name="push_message"
                        id="push_message"
                        class="form-control input-sm"
                        rows="5"
                        placeholder="Enter Push Message"
                      >
                      </textarea>
                      <small v-if="errors.push_message" class="text-danger">{{
                        errors.push_message
                      }}</small>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-4 control-label">Image URL </label>
                    <div class="col-md-8">
                      <input
                        type="url"
                        v-model="formData.big_picture"
                        name="big_picture"
                        id="big_picture"
                        class="form-control input-sm"
                        placeholder="e.g. http://69.30.193.85/images/logo.png"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-4 control-label"
                      >URL for Android
                    </label>
                    <div class="col-md-8">
                      <input
                        type="url"
                        v-model="formData.launch_url_android"
                        name="launch_url_android"
                        id="launch_url_android"
                        class="form-control input-sm"
                        placeholder="Enter launch url for android"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-4 control-label">URL for iOS </label>
                    <div class="col-md-8">
                      <input
                        type="url"
                        v-model="formData.launch_url_ios"
                        name="launch_url_ios"
                        id="launch_url_ios"
                        class="form-control input-sm"
                        placeholder="Enter launch url for iOS"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12 btnRight" id="clearBtn">
                      <a
                        href="javascript:void(0)"
                        @click="clearForm()"
                        class="btn bg-red-gradient btn-sm btn-warning btn-payment"
                      >
                        Clear
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 btnCenter">
            <button
              type="button"
              id="display_user"
              @click="displayUser"
              class="btn btn-sm btn-submit btn-submit-big"
            >
              Display Total User
            </button>
            <input
              type="submit"
              name="submit"
              id="sendPush"
              value="Send Now"
              class="btn btn-sm btn-submit btn-submit-big"
            />
          </div>
          <input
            type="hidden"
            id="alert_msg"
            value="Are you sure to send push now?"
          />
          <input
            type="hidden"
            name="display_list"
            id="display_list"
            value="1"
          />
        </form>
      </div>
      <div class="col-md-12" id="countBox">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">
              <i class="fa fa-info-circle"></i>
              Result of filtered data for push
            </h3>
          </div>
          <div class="box-body form-box-body form-horizontal">
            <h4 style="color: #0f9b0f; font-weight: bold">
              <i class="fa fa-user-circle" style="color: #000"></i>
              Total users found for this push is :
              <span id="totaluserfounds" style="color: red">0</span>
            </h4>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
  },
  name: "SendPush",
  data() {
    return {
      name: "",
      description: "",
      status: true,
      alert_message: "",
      error_name: false,
      bundles: [],
      rateplans: [],
      prefix: "",
      username: "",
      rate_plan_id: null,
      plan_id: "",
      password: "",
      formData: {
        pin_type: "",
        username: "",
        status: {
          active: true,
          inactive: false,
          expired: false,
        },
        subscriptions_selection_type: "",
        subscriptions: [],
        country_filter_type: "",
        country: [],
        device_type: "",
        date_column: "",
        date_condition: "",
        date_range: {
          start: "",
          end: "",
        },
        headings: "",
        push_message: "",
        big_picture: "",
        launch_url_android: "",
        launch_url_ios: "",
      },
      showEndDate: false,
      dateRangeLabel: "",
      selectedCondition: "=",
      countries: [],
      errors: {},
      filteredCountries: [],
    };
  },

  created() {
    this.com_user_type_access([0, 1], true);
    var encryptedData = this.$store.getters.getUser;
    var decodedString = this.com_DecryptString(encryptedData);
    this.userData = JSON.parse(decodedString);
    this.prefix = this.userData.reseller4.branding_pin_prefix;
    var rootObject = this;
    loader.show();
    axios
      .get("rate-plan?status=1")
      .then(function (response) {
        rootObject.bundles = response.data;
        loader.hide();
      })
      .catch(function (error) {
        let alertmessage = "";
        for (var prop in error.response.data) {
          alertmessage += " " + error.response.data[prop];
        }
        loader.hide();
        rootObject.com_errorHandel(error);
      });
  },
  mounted() {
    this.showPinTypeHide();
    this.loadCountryiesDropDown();
    $("#countBox").hide();
    const vm = this;
    $(".datePicker")
      .datetimepicker({
        timepicker: false,
        format: "Y-m-d",
        autoclose: true,
      })
      .on("change", function (e) {
        const inputId = $(this).attr("id");
        if (inputId === "starttime") {
          vm.formData.date_range.start = $(this).val();
        } else if (inputId === "stoptime") {
          vm.formData.date_range.end = $(this).val();
        }
      });
  },
  methods: {
    loadCountryiesDropDown() {
      const rootObject = this;
      loader.show();
      axios
        .get("get-countries")
        .then(function (response) {
          var tmpList = response.data;
          tmpList = [...new Set(tmpList)];
          rootObject.countries = tmpList;
          loader.hide();
        })
        .catch(function (error) {
          let alertmessage = "";
          if (error.response && error.response.data) {
            for (let prop in error.response.data) {
              alertmessage += " " + error.response.data[prop];
            }
          } else {
            alertmessage = "An unexpected error occurred.";
          }
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    formValidationUser() {
      this.errors = {};
      var validationFlag = false;

      if (this.formData.pin_type === "single" && !this.formData.username) {
        this.errors.username = "Please enter username";
        validationFlag = true;
      }
      if (
        this.formData.subscriptions_selection_type === "include" &&
        !this.formData.subscriptions.length
      ) {
        this.errors.subscriptions = "Please select subscriptions";
        validationFlag = true;
      }
      if (
        this.formData.country_filter_type &&
        this.formData.country.length < 1
      ) {
        this.errors.country = "Please select country";
        validationFlag = true;
      }
      if (this.formData.date_column && !this.formData.date_condition) {
        this.errors.date_condition = "Please select date condition";
        validationFlag = true;
      }

      if (
        this.formData.date_condition === "between" ||
        this.formData.date_condition === "not between"
      ) {
        if (!this.formData.date_range.start) {
          this.errors.date_range_start = "Please select start date";
          validationFlag = true;
        }
        if (!this.formData.date_range.end) {
          this.errors.date_range_end = "Please select end date";
          validationFlag = true;
        }
      }

      if (this.formData.date_column && this.formData.date_condition) {
        if (
          this.formData.date_condition !== "between" ||
          this.formData.date_condition !== "not between"
        ) {
          if (!this.formData.date_range.start) {
            this.errors.date_range_start = "Please select start date";
            validationFlag = true;
          }
        }
      }

      return validationFlag;
    },

    formValidation() {
      this.errors = {};
      var validationFlag = false;

      if (this.formData.pin_type === "single" && !this.formData.username) {
        this.errors.username = "Please enter username";
        validationFlag = true;
      }

      if (
        this.formData.country_filter_type &&
        !this.formData.country?.length < 1
      ) {
        this.errors.country = "Please select country";
        validationFlag = true;
      }
      if (this.formData.date_column && !this.formData.date_condition) {
        this.errors.date_condition = "Please select date condition";
        validationFlag = true;
      }

      if (
        this.formData.date_condition === "between" ||
        this.formData.date_condition === "not between"
      ) {
        if (!this.formData.date_range.start) {
          this.errors.date_range_start = "Please select start date";
          validationFlag = true;
        }
        if (!this.formData.date_range.end) {
          this.errors.date_range_end = "Please select end date";
          validationFlag = true;
        }
      }
      if (
        this.formData.subscriptions_selection_type === "include" &&
        !this.formData.subscriptions.length
      ) {
        this.errors.subscriptions = "Please select subscriptions";
        validationFlag = true;
      }
      if (!this.formData.headings) {
        this.errors.headings = "Please enter title";
        validationFlag = true;
      }
      if (!this.formData.push_message) {
        this.errors.push_message = "Please enter push message";
        validationFlag = true;
      }
      return validationFlag;
    },
    formSubmit() {
      if (this.formValidation()) {
        return;
      }
      var rootObject = this;
      var msg = "Are you sure to send push now?";
      $.confirm({
        title: "Confirm!",
        content: msg,
        buttons: {
          yes: function () {
            loader.show();
            const formElement = rootObject.$refs.myForm;
            const formData = new FormData(formElement);
            axios
              .post("/send-push", {
                ...rootObject.formData,
              })
              .then(function (response) {
                if (response?.data?.status_code === 200) {
                  loader.hide();
                  window.location.reload();
                } else {
                  loader.hide();
                  $.alert("Failed to send push.");
                }
              })
              .catch(function (error) {
                rootObject.com_errorHandel(error);
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += " " + error.response.data[prop];
                }
                loader.hide();
                $.alert(alertmessage);
              });
          },
          no: function () {
            return;
          },
        },
      });
    },

    loadRatePlans() {
      var rootObject = this;
      if (this.rate_plan_id) {
        loader.show();

        axios
          .get("get-rates-by-plan-id/" + this.rate_plan_id)
          .then(function (response) {
            rootObject.rateplans = response.data.rates;
            rootObject.plan_id = "";
            loader.hide();
          })
          .catch(function (error) {
            let alertmessage = "";
            for (var prop in error.response.data) {
              alertmessage += " " + error.response.data[prop];
            }
            loader.hide();
            rootObject.com_errorHandel(error);
          });
      } else {
        rootObject.rateplans = [];
        rootObject.plan_id = "";
      }
    },

    checkDateCondition() {
      if (
        this.formData.date_condition === "between" ||
        this.formData.date_condition === "not between"
      ) {
        this.showEndDate = true;
        this.dateRangeLabel = "Range";
      } else {
        this.showEndDate = false;
        this.dateRangeLabel = "";
        this.formData.date_range.end = "";
      }
    },

    checkDateColumn() {
      if (!this.formData.date_column) {
        this.formData.date_condition = "";
        this.formData.date_range.start = "";
        this.formData.date_range.end = "";
      }
    },

    clearForm() {
      var msg = "Are you sure to clear the form?";
      var rootObject = this;
      $.confirm({
        title: "Confirm!",
        content: msg,
        buttons: {
          yes: function () {
            loader.show();
            rootObject.formData = {
              pin_type: "",
              username: "",
              status: {
                active: true,
                inactive: false,
                expired: false,
              },
              subscriptions_selection_type: "",
              subscriptions: [],
              country_filter_type: "",
              country: [],
              device_type: "",
              date_column: "",
              date_condition: "",
              date_range: {
                start: "",
                end: "",
              },
              headings: "",
              push_message: "",
              big_picture: "",
              launch_url_android: "",
              launch_url_ios: "",
            };
            $("#countBox").hide();
            loader.hide();
            $("#totaluserfounds").text("0");
          },
          no: function () {
            return;
          },
        },
      });
    },

    displayUser() {
      if (this.formValidationUser()) {
        return;
      }
      const payload = {
        pin_type: this.formData.pin_type,
        username: this.formData.username,
        status: this.formData.status,
        subscriptions_selection_type: this.formData
          .subscriptions_selection_type,
        subscriptions: this.formData.subscriptions,
        country_filter_type: this.formData.country_filter_type,
        country: this.formData.country,
        device_type: this.formData.device_type,
        date_column: this.formData.date_column,
        date_condition: this.formData.date_condition,
        date_range: this.formData.date_range,
      };
      loader.show();
      axios
        .post("/get-push-user-list-count", { ...payload })
        .then((response) => {
          if (response?.data?.result?.toLowerCase() === "success") {
            $("#countBox").show();
            loader.hide();
            $("#totaluserfounds").text(response?.data.data);
          } else {
            throw new Error("Failed to get user count.");
          }
        })
        .catch((error) => {
          loader.hide();
          alert("Failed to get user count.");
          console.error("Error submitting form:", error);
        });
    },

    showPinTypeHide() {
      if (this.formData.pin_type === "single") {
        $(".username-div").show();
      } else {
        $(".username-div").hide();
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-danger {
  color: red;
}
.inputFlex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
</style>
